import { render } from "./File.vue?vue&type=template&id=77c84e67&scoped=true"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"

import "./File.vue?vue&type=style&index=0&id=77c84e67&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c84e67"],['__file',"resources/js/components/File.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77c84e67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77c84e67', __exports__)) {
    console.log('reload')
    api.reload('77c84e67', __exports__)
  }
  
  module.hot.accept("./File.vue?vue&type=template&id=77c84e67&scoped=true", () => {
    console.log('re-render')
    api.rerender('77c84e67', render)
  })

}


export default __exports__